<template lang="slm">
footer.Footer
  .container
    .columns.is-multiline
      .column.is-12.is-3-desktop.is-2-widescreen
        img src="/static/images/ru_logo_hvit.svg" width='120'  alt="Rød Ungdom"
        a.is-hidden href="https://rødungdom.no"
          span itemprop="name"  Rød Ungdom
      .column.is-4.is-3-desktop
        p
          span.Knekk Dronningens gate 22
          span
            | 0154 Oslo
          br
          a(href='tel:229890(0') 22 98 90 70
          br
          a(href='mailto:ru@sosialisme.no') ru@sosialisme.no
      .column.is-4.is-3-desktop(itemscope itemtype="http://schema.org/Person")
        <!-- p
          span(itemprop="jobTitle") Pressekontakt
          br
          span(itemprop="name") Iver Aastebøl
          br
          a(href='tel:98414170' itemprop="telephone") 984 14 170
          br
          a(href='mailto:iver@roedt.no' itemprop="email") iver@roedt.no -->
      .column.is-4.is-3-desktop
        p
          a(href='https://www.facebook.com/rodungdomnorge' target='_blank')
            icon name="facebook-official"
            | Facebook
          br
          a(href='https://www.instagram.com/rod_ungdom/' target='_blank')
            icon name="instagram"
            | Instagram
          br
          a(href='https://twitter.com/rodungdom' target='_blank')
            icon name="twitter"
            | Twitter
          br
          a(href='/personvernerklaering') Personvernerklæring
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/facebook-official'
import 'vue-awesome/icons/instagram'
import 'vue-awesome/icons/twitter'
import 'vue-awesome/icons/flickr'

export default {
  components: {
    Icon
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue